import { Component, OnInit } from '@angular/core';
import { ProfileFacade } from '@tekman/onmat/store/profile';

export interface ErrorObject {
  title: string;
  description: string;
  img: string;
  buttonText?: string;
  button: boolean;
}

@Component({
  selector: 'onmat-error-notfound',
  templateUrl: './error-notfound.component.html',
  styleUrls: ['./error-notfound.component.scss'],
})
export class ErrorNotfoundComponent implements OnInit {
  constructor(private profileFacade: ProfileFacade) {}

  ngOnInit() {
    this.profileFacade.notFound('404_ERROR');
  }
}
